import { getModelById } from '../voxel/models.js';
import { buildValidatedSlices } from '../voxel/slicePipeline.js';
import { puzzleEngine } from '../logic/PuzzleEngine.js';

/** Bump when tutorial content changes so returning players see the new lesson once. */
export const BOOTCAMP_STORAGE_KEY = 'bootcamp_complete_v3';

/**
 * Tiny cross — easy to explain with row/col run lengths.
 * Rows: [2] [4] [4] [2] · Cols: [2] [4] [4] [2]
 */
const MICRO_4X4 = [
    [0, 1, 1, 0],
    [1, 1, 1, 1],
    [1, 1, 1, 1],
    [0, 1, 1, 0],
];

const microClues = puzzleEngine.generateClues(MICRO_4X4);

const heart = getModelById('heart_8_tutorial');
const heartSlices = buildValidatedSlices(heart, 2);

const microTile = {
    id: 'b_lesson_4x4',
    index: 0,
    status: 'OPEN',
    type: 'BOOTCAMP',
    data: {
        axis: 'y',
        index: 0,
        clue: 'Practice 4×4',
        clues: microClues,
        solutionGrid: MICRO_4X4,
        modelId: 'heart_8_tutorial',
        tutorial: {
            guided: true,
            size: 4,
            title: 'Lesson 1 · Guided 4×4',
            blurb: 'Only this board is super-guided — glowing cells show exactly what to DRAW and MARK.',
        },
    },
};

const heartTiles = heartSlices.map((s, i) => ({
    id: `b_${s.axis}_${s.index}`,
    index: i + 1,
    status: 'OPEN',
    type: 'BOOTCAMP',
    data: {
        axis: s.axis,
        index: s.index,
        clue: `${s.axis.toUpperCase()}=${s.index}`,
        clues: s.clues,
        solutionGrid: s.solutionGrid,
        modelId: 'heart_8_tutorial',
        tutorial: {
            guided: false,
            size: 8,
            title: `On your own · Heart ${i + 1}`,
            blurb: 'No glowing hints here — same DRAW / MARK rules as the lesson.',
        },
    },
}));

export const BOOTCAMP_CONFIG = {
    id: 'bootcamp_vq_guided_v3',
    modelId: 'heart_8_tutorial',
    modelName: 'Heart',
    size: 8,
    grid: [microTile, ...heartTiles],
};

/** Hub intro cards before the player opens a workbench. */
export const BOOTCAMP_INTRO_STEPS = [
    {
        id: 'welcome',
        stamp: '[TUTORIAL]',
        title: 'Welcome to Voxel Atelier',
        body: 'You restore a hidden 3D voxel sculpture (a Heart) by solving 2D slices — like cutting planes through the object.',
    },
    {
        id: 'nonogram',
        stamp: '[NONOGRAM]',
        title: 'Each slice is a nonogram',
        body: 'Numbers on the side and top say how many filled (orange) cells sit in that row or column, in order. Example: 2 means two orange cells in a block.',
    },
    {
        id: 'tools',
        stamp: '[TOOLS]',
        title: 'DRAW and MARK',
        body: 'DRAW = orange clay. MARK = X on empty cells. The first 4×4 lights up the exact cells to paint so you learn by doing.',
    },
    {
        id: 'ready',
        stamp: '[PRACTICE]',
        title: 'Guided lesson, then free practice',
        body: 'Start the free 4×4 — we’ll highlight DRAW then MARK. After that we’ll highlight the exact Heart planes (like Y=1 / Y=2) to tap next.',
    },
];
